var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%"}},[(_vm.showHeader)?_c('el-header',{staticClass:"mainHeader",attrs:{"height":"auto"}},[_vm._t("header")],2):_vm._e(),_c('el-main',{staticClass:"mainScroll"},[_vm._t("default")],2),(_vm.showFooter)?_c('el-footer',{staticClass:"mainFooter",attrs:{"height":"auto"}},[_vm._t("footer")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }